<button class="c-button c-button--tp u-no-p" type="button" id="openPopUpInfoButton" (click)="vm.handleRefButtonClick()" data-ref>
    <i class="o-icon o-icon--info" aria-hidden="true"></i>
</button>
<div class="c-popover" *ngIf="vm.isOpen">
    <div class="c-popover__container">
        <button type="button" class="c-popover__close" id="closePopUpInfoButton" (click)="vm.handleCloseButtonClick()">
            <i class="o-icon o-icon--x" aria-hidden="true"></i>
            <span class="u-sr-only">{{ 'Common.Close' | translate }}</span>
        </button>
        <p class="c-text" style="margin-bottom: 8px">
            {{ vm.data }}
        </p>
    </div>
</div>
